<template>
  <div class="bottom-sheet">
    <div class="pricing-section">
      <span class="pricing-subtitle">합계 (VAT 포함)</span>
      <span class="pricing-title"> {{ activeTab === 'store' ? '월 기준' : '' }} {{ formattedPrice }}원 </span>
    </div>
    <button class="consultation-button" @click="handleOpenModal">무료 상담하기</button>
  </div>
</template>

<script>
export default {
  name: 'BottomSheet',
  props: {
    selectedPlan: {
      type: Number,
      required: true,
    },
    plans: {
      type: Object,
      required: true,
    },
    packages: {
      type: Object,
      required: true,
    },
    selectedPackage: {
      type: Number,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
  },

  computed: {
    formattedPrice() {
      if (this.activeTab === 'store') {
        return (this.plans[this.selectedPlan].priceNumber * 1.1).toLocaleString();
      } else if (this.activeTab === 'product') {
        return (this.packages[this.selectedPackage].priceNumber * 1.1).toLocaleString();
      }
      return '0'; // 기본값 반환
    },
  },
  methods: {
    handleOpenModal() {
      this.$emit('click-free-trial');
    },
  },
};
</script>

<style scoped lang="scss">
.bottom-sheet {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;

  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;

  border-radius: 12px 12px 0px 0px;
  background: #1f2130;

  transition: transform 0.3s ease;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
  gap: 12px;
  width: 100%;
  max-width: 375px;
  height: 140px;
  background: #202020;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.info-section {
  display: none; // 이미지에서 보이지 않으므로 숨김
}

.company-info {
  .info-text {
    font-family: 'Spoqa Han Sans Neo';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #c2c2c2;
    margin: 0;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.pricing-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  padding: 0 8px;
}

.pricing-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 8px;
  gap: 8px;
  width: 343px;
  height: 54px;
  flex: none;
  order: 0;
  flex-grow: 1;
}

.pricing-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.pricing-subtitle {
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #c2c2c2;
  margin: 0;
  width: 327px;
  height: 18px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.pricing-title {
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
  margin: 0;
  width: 160px;
  height: 28px;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.consultation-button {
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-radius: 8px;
  background: var(--inversed, #fff);

  &:hover {
    background: #f5f5f5;
  }

  &:active {
    transform: translateY(1px);
  }
}

// 모바일에서만 표시
@media (min-width: 781px) {
  .bottom-sheet {
    display: none;
  }
}
</style>
